import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import { globalStyles } from './style/gstheme';
import { getLabelDisplayLangFromLabel, getLabelTextFromLabel } from '../core/utils/utils';

const styles = Object.assign({
  componentTitle: {
    display: 'flex',
    alignItems: 'start',
    position: 'absolute',
    left: '380px',
    top: '39px',
    right: '30px',
  },
  componentTitleAV: {
    display: 'flex',
    alignItems: 'start',
    position: 'absolute',
    left: '480px',
    top: '39px',
    right: '30px',
  }, componentMH: {
    fontFamily: 'rajdhani',
    color: '#13294B',
    fontWeight: 500,
    fontSize: '24px',
    margin: '0px 6px 0px 0px',
    padding: '0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
      cursor: 'pointer',
      color: '#50832C'
    }
  },
  componentButton: {
    marginLeft: 12,
    color: '#97d700',
    backgroundColor: '#f0f0f0'
  }
}, globalStyles);

class ComponentTitle extends Component {

  render() {

    const { title, classes, defaultLang, onClick, defaultDirection, viewLang, id, advancedView } = this.props;

    const displayLang = getLabelDisplayLangFromLabel(title, viewLang, defaultLang);
    const label = getLabelTextFromLabel(title, id, displayLang, id);
    const fallbackLang = viewLang && title && !title[viewLang];

    return (
      <div data-test="component-title" className={advancedView ? classes.componentTitleAV : classes.componentTitle}>
        <h6
          className={classes.componentMH}
          onClick={onClick}
          data-fallbacklang={fallbackLang}
          style={fallbackLang ? { color: '#CA4F0C' } : {}}>
          <Tooltip placement="top" title={defaultDirection ? "Click to show management panel" : "Click to hide management panel"}>
            <span>
              {label}
            </span>
          </Tooltip>
        </h6>
        <Tooltip placement="right" title={defaultDirection ? "Show management panel" : "Hide management panel"}>
          <IconButton
            onClick={onClick}
            aria-label={defaultDirection ? "Show management panel" : "Hide management panel"}
            data-test="toggle-component-view"
            size="small"
            className={classes.componentButton}>
            {defaultDirection ? <SettingsApplicationsIcon /> : <CloseIcon />}
          </IconButton>
        </Tooltip>
      </div>
    );
  }
}

ComponentTitle.defaultProps = {
  defaultDirection: true,
  advancedView: false,
  viewLang: null
};

ComponentTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  advancedView: PropTypes.bool,
  title: PropTypes.object,
  defaultDirection: PropTypes.bool,
  viewLang: PropTypes.string,
  id: PropTypes.string,
  defaultLang: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(ComponentTitle);